import { ROUTE } from "../../../routes";
import { getApplicationId, getPendingCreditRequestByCreditId } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { LENDER_ID } from "../../../configs/constants";
export const goBack = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.LOAN_RENEWAL_LANDING_PAGE);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navNext = async (action, _datastore, { network, navigateWithClear, navigate, setDatastore }) => {
    const applicationId = await getApplicationId();
    const user = await SharedPropsService.getUser();
    const lender = user?.linkedCredits[0]?.lendingPartnerId;
    let response;
    let counter = 0;
    await setDatastore(ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE, 'loanRenewalLearnMorePage', {
        isLoading: true,
    });
    const getOfferSelectionVerifyResponse = await network.get(`${api.getOfferSelectionVerify}${applicationId}`, {
        headers: await getAppHeader()
    });
    if (getOfferSelectionVerifyResponse?.status === 200 && lender?.toLowerCase() === LENDER_ID.BAJAJ) {
        await navigateWithClear(ROUTE.KYC_STEPPER);
        return;
    }
    const runPollar = async () => {
        response = network.get(`${api.borrowerApplication}${applicationId}`, {
            headers: await getAppHeader(),
        }).then((response) => {
            if (response.data.applicationState === 'COMPLETED') {
                clearInterval(timer);
                if (getOfferSelectionVerifyResponse?.status === 200) {
                    if (lender?.toLowerCase() === LENDER_ID.TATA) {
                        let pendingResponse = getPendingCreditRequestByCreditId(network, {
                            overrideCache: true
                        });
                        navigate(ROUTE.LOAN_RENEWAL_STATUS_PAGE, {
                            //@ts-ignore
                            renewalRequestDetailsList: pendingResponse?.renewalRequestDetailsList,
                        });
                    }
                    else
                        navigateWithClear(ROUTE.KYC_STEPPER);
                    setDatastore(ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE, 'loanRenewalLearnMorePage', {
                        isLoading: false,
                    });
                }
            }
        });
    };
    await runPollar();
    const timer = setInterval(async () => {
        await runPollar();
    }, APP_CONFIG.POLLING_INTERVAL);
};
